import React from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';

import useReportStore from '../../store/ReportStore';
import type { MappedReportT, ReportMappedRowT } from '../../types';
import ReportColumn from './ReportColumn';
import ReportColumnDropzone from './ReportColumnDropzone';

type Props = {
  report: MappedReportT;
  row: ReportMappedRowT;
  rowHeight: StringNumberValue;
};

const ReportRow = (props: Props) => {
  const { row } = props;
  const cardWidth = `calc(100% / ${props.row.columns?.length})`;
  const dragging = useReportStore((state) => state.dragging);
  return (
    <Style id={row.alias} style={{ height: props.rowHeight }}>
      {row.mapped_columns.map((column, index) => (
        <React.Fragment key={column.alias}>
          <ReportColumn
            key={column.alias}
            column={column}
            width={cardWidth}
            index={index}
            report={props.report}
          />
        </React.Fragment>
      ))}
      <Flex
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: dragging ? 1 : -1,
          opacity: dragging ? 1 : 0,
        }}
      >
        {row.mapped_columns.map((column, index) => {
          return (
            <ReportColumnDropzone
              key={column.alias}
              rowId={row.alias}
              columns={row.mapped_columns}
              zoneIndex={index}
            />
          );
        })}
        <ReportColumnDropzone
          rowId={row.alias}
          columns={row.mapped_columns}
          zoneIndex={row.mapped_columns.length}
        />
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  position: relative;
`;

export default ReportRow;
